export default __webpack_public_path__ + "static/vision1Mobile-2079a0b7ab729fbc9a2b455120c24427.png";